define(['./environment.common'], function(common) {

	return Object.assign(common, {
		DEBUG: false,

		VERSION: 'REPLACE_WITH_IDM_VERSION',

		REPORT_URL: 'https://ps.ecsec.de',
		REPORT_HEADERS: {
			'X-Redmine-API-Key': 'REPLACE_WITH_REDMINE_API_KEY'
		},
		REPORT_DATA: {
			ISSUE: {
				PROJECT_ID: '20',
				TRACKER_ID: '1',
				STATUS_ID: '1',
				PRIORITY_ID: '4',
				CATEGORY_ID: '13',
				SUBJECT: 'IDM Error Report',
				ASSIGNED_TO_ID: '61',
				WATCHER_USER_IDS: [
					'61', '3', '5'
				]
			}
		},

        MANAGEMENT_SERVICE_URL: "REPLACE_WITH_SP_BASE_URL/management",

        IDM_URL: 'REPLACE_WITH_BASE_URL/idm/w3/finish/index.html',

        FF_IDM_START_URL: "REPLACE_WITH_BASE_URL/idm/ff-ekiosk/start/",
        FF_IDM_FINISH_URL: "REPLACE_WITH_BASE_URL/idm/ff-ekiosk/finish/",

		OPTIONS_URL: 'REPLACE_WITH_BASE_URL/broker/api/pub/v1/options',
		SELECT_OPTION_URL: 'REPLACE_WITH_BASE_URL/broker/api/pub/v1/options/select',
		SESSION_CLAIM_URL: 'REPLACE_WITH_BASE_URL/broker/api/pub/v2/session/claim',
		CANCEL_SELECT_OPTION_URL: 'REPLACE_WITH_BASE_URL/broker/api/pub/v1/options/cancel',
		ATTRIBUTE_DEFINITIONS_URL: 'REPLACE_WITH_BASE_URL/broker/api/pub/v1/attribute/LANG/definitions',
		PRIVACY_DOCUMENT_URL: 'https://www.skidentity.de/fileadmin/Ecsec-files/pub/LANG/SkIDentity-privacy-statement.pdf',
		PAIRING_URL: 'wss://REPLACE_WITH_BASE_DOMAIN/pairing/pair',

		CLOUD_IDENTITY_REQUEST_URL: 'REPLACE_WITH_BASE_URL/fs/cloudid/api/pub/v1/cip/',
		CLOUD_IDENTITY_MANAGEMENT_URL: 'REPLACE_WITH_BASE_URL/fs/cloudid/api/pub/v1/',

		EID_CLIENT_ATTRIBUTE_SELECTION: [
			'http://bsi.bund.de/cif/npa.xml'
		],
		EID_CLIENT_DETECTION_INTERVAL: 3000,

		OPEN_ECARD_MINIMUM_JRE_VERSION: '1.7.0',
		OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_URL: 'REPLACE_WITH_PATH_TO_CARD_PROTOCOLS',
		OPEN_ECARD_DOWNLOAD_URL: 'https://www.openecard.org/en/download/pc/',
		OPEN_ECARD_APP_STATUS_URL: 'http://127.0.0.1:24727',
		OPEN_ECARD_APP_COMMUNICATION_TIMEOUT: 1000,

		JAVA_DOWNLOAD_URL: 'https://www.java.com/download/',

        TENANT_API_URL: 'REPLACE_WITH_TENANT_API_URL',

		RECOVERY_STRATEGY_WEBSTART_TIMEOUT: 60000,

		FIDO_TIMEOUT: 15,

		IMAGES_URL: 'img/',
		IMAGES: {
            TRACKER_IMG : {
                image : "Tracker.svg",
                width : 800,
                height : 15
            },
            TRACKER_IMG_1 : {
                image : "Tracker_1.lif.png",
                width : 800,
                height : 15
            },
            TRACKER_IMG_2 : {
                image : "Tracker_2.lif.png",
                width : 800,
                height : 15
            },
            TRACKER_IMG_3 : {
                image : "Tracker_3.lif.png",
                width : 800,
                height : 15
            },
            TRACKER_IMG_4 : {
                image : "Tracker_4.lif.png",
                width : 800,
                height : 15
            },
			FIDO_ICON: {
				image: 'fido-u2f.png',
				width: 82,
				height: 100
			},
			FIDO_ANI: {
				image: 'fido_ani.gif',
				width: 82,
				height: 100
			},
			FIDO_ANI_PNG: {
				image: 'fido_ani.png',
				width: 82,
				height: 100
			},
			FIDO_ANI_MP4: {
				image: 'fido_ani.mp4',
				width: 82,
				height: 100
			},
			FIDO_ANI_OGV: {
				image: 'fido_ani.ogv',
				width: 82,
				height: 100
			},
			IDS_MOBILE: {
				image: 'ids_mobile_2.png',
				width: 986,
				height: 986
			},
			IDS_MOBILE_QR : {
				image : "ids_mobile_3.png",
				width : 986,
				height : 986
			},
			IDS_LOCAL: {
				image: 'ids_local.png',
				width: 986,
				height: 647
			},
			CLOUDID_ICON: {
				image: 'cloudid.png',
				width: 23,
				height: 23
			},
			SERVER_ICON: {
				image: 'server.png',
				width: 82,
				height: 100
			},
			PDF_ICON: {
				image: 'pdf.png',
				width: 128,
				height: 153
			},
			WEBSTART_RECOVERY_BUTTON: {
				de: {
					image: 'webstart-recovery-de.png',
					width: 513,
					height: 162
				},
				en: {
					image: 'webstart-recovery-en.png',
					width: 513,
					height: 162
				}
			},
			OPEN_ECARD_APP_RECOVERY_BUTTON: {
				de: {
					image: 'open-ecard-app-recovery-de.png',
					width: 513,
					height: 162
				},
				en: {
					image: 'open-ecard-app-recovery-en.png',
					width: 513,
					height: 162
				}
			},
			MANUAL_RECOVERY_BUTTON: {
				de: {
					image: 'eID-Client.png',
					width: 513,
					height: 162
				},
				en: {
					image: 'eID-Client.png',
					width: 513,
					height: 162
				}
			},
			CUSTOM_PROTOCOL_RECOVERY_BUTTON: {
				de: {
					image: 'custom-protocol-recovery-de.png',
					width: 513,
					height: 162
				},
				en: {
					image: 'custom-protocol-recovery-en.png',
					width: 513,
					height: 162
				}
			}
		},
		IMAGES_TO_PRELOAD: [
			'CLOUDID_ICON',
			'SERVER_ICON',
			'PDF_ICON',
			'WEBSTART_RECOVERY_BUTTON',
			'OPEN_ECARD_APP_RECOVERY_BUTTON',
			'MANUAL_RECOVERY_BUTTON',
			'CUSTOM_PROTOCOL_RECOVERY_BUTTON'
		],

		LOGO_CANVAS_INTERVAL: 300,
		LOADING_CANVAS_INTERVAL: 25
	});
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/environment/environment-docker.js
// module id = 167
// module chunks = 5